import { Search as SearchIcon } from 'lucide-react';
import Cards from '../elements/Cards';
import Hero from '../elements/Hero';
import { allDetailPages } from '../data/siteData';

function Search() {
  return (
    <>
      <Hero eyebrow="Search" title="Find a C&M product or service." description="Browse the rebuilt site index for products, services, industries, and selection guide pages." image="equipment/horizontal-balers/horizontal-8.jpg" compact />
      <main>
        <section>
          <div className="search-box"><SearchIcon size={22} /><span>Site index</span></div>
          <Cards items={allDetailPages} label="Open page" />
        </section>
      </main>
    </>
  );
}

export default Search;
